<template>
  <div>
    <Breadcrumbs main="" title="bookingTx.header" />
    <b-container fluid>
      <h2 class="mb-1 mt-4 f-w-600">{{ $t('bookingTx.header') }}</h2>
      <div>
          <b-row>
            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.sort')"
                label-for="sort-by-select"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-input-group size="lg">
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    :aria-describedby="ariaDescribedby"
                    class="w-70 text-info"
                  >
                    <template #first>
                      <option value="">-- none --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    :aria-describedby="ariaDescribedby"
                    size="lg"
                    class="w-30 text-info"
                  >
                    <option :value="false">{{$t('matchTx.asc')}}</option>
                    <option :value="true">{{$t('matchTx.desc')}}</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.initSort')"
                label-for="initial-sort-select"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-form-select
                  id="initial-sort-select"
                  v-model="sortDirection"
                  :options="['asc', 'desc', 'last']"
                  size="lg"
                  class="text-info"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.filter')"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    :placeholder="$t('matchTx.typeToSearch')"
                    class="text-info"
                    style="font-size: 18px;"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                      {{ $t('matchTx.clear') }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="5" class="my-1">
              <b-form-group
                v-model="sortDirection"
                :label="$t('matchTx.filterOn')"
                :description= "$t('matchTx.uncheck')"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-form-checkbox-group
                  v-model="filterOn"
                  :aria-describedby="ariaDescribedby"
                  class="mt-1 text-info"
                  plain
                >
                  <b-form-checkbox value="agent">{{ $t('matchTx.agent') }}</b-form-checkbox>
                  <b-form-checkbox value="commodity">{{ $t('getQuote.commodity') }}</b-form-checkbox>
                  <b-form-checkbox value="fghtCat">{{ $t('freight.cat') }}</b-form-checkbox> 
                  <b-form-checkbox value="POL">{{ $t('getQuote.POL') }}</b-form-checkbox>         
                  <b-form-checkbox value="POD">{{ $t('getQuote.POD') }}</b-form-checkbox>     
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="row justify-content-start ml-2">
            <feather 
                @click="refreshBookingTx" 
                class="text-primary" 
                type="refresh-cw"  
                size="25" 
                v-b-popover.hover.top="$t('approvedTrans.refreshTaskListMsg')">
              </feather>  
                <span class="texrt-dark mx-2"> {{ $t('approvedTrans.asOf') }}</span>
                <span class="text-primary"> {{ asOf }} </span>   
            </div>
        <b-table
          sticky-header
          show-empty
          bordered
          responsive
          sort-icon-left
          stacked="md"
          :busy="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          @filtered="onFiltered"
        >
        <!-- <template #thead-top="">
        <b-tr>
          <b-th colspan="2"><span class="sr-only">mTxId and BkgId</span></b-th>
          <b-th variant="info" colspan="7" class="tableInfo">{{ $t('matchTx.contInfo') }}</b-th>
          <b-th colspan="2"><span class="sr-only">sealShip</span></b-th>
          <b-th variant="danger" colspan="3" class="tableInfo">{{ $t('matchTx.jobStatusMtx') }}</b-th>
          <b-th colspan="2"><span class="sr-only"></span></b-th>
          <b-th variant="success" colspan="4" class="tableInfo">{{ $t('release.header') }}</b-th>
          <b-th variant="primary" colspan="4" class="tableInfo">{{ $t('require.header') }}</b-th>
          <b-th variant="warning" colspan="3" class="tableInfo">{{ $t('matchTx.transportation') }}</b-th>
        </b-tr>
      </template> -->
          <template #cell(index)="data">
              {{ data.index + 1 }}
          </template>
          <template #cell(detailsPOL)="row" >
              <b-button size="sm" @click="openModalDetailsPOL(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('freight.detailsPort')">
                  {{ row.item.POL}}
              </b-button>
          </template>
          <template #cell(detailsPOD)="row" >
              <b-button size="sm" @click="openModalDetailsPOD(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('freight.detailsPort')">
                  {{ row.item.POD}}
              </b-button>
          </template>
          <template #cell(jbBTx)="row" >
            <!-- <b-button  size="sm" @click="openModalJbBTx(row.item )" variant="outline-dark" v-b-popover.hover.top="$t('matchTx.jobStatusDetails')">
              {{ $t(`bookingTx.${row.item.jbBTx}`) }}
            </b-button> -->
            <b-button  size="sm" @click="openModalJbBTx(row.item )" variant="outline-dark" v-b-popover.hover.top="$t('matchTx.jobStatusDetails')">
              {{ $t('bookingTx.' + (row.item.jbBTx || 'default')) }}
            </b-button>
          </template>
          <template #cell(detailsCommodity)="row" >
              <b-button size="sm" @click="openModalDetailsCommodity(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('getQuote.detailsCommodity')">
                  {{ row.item.commodity}}
              </b-button>
          </template>    
          <template #cell(contSQWArr)="row" >
              <div
                v-for="(sqw, index) in row.item.contSQW"
                :key="index"
                class="select-group-sqw"
              >
                <span class="ml-2"># {{index + 1}}:</span>         
                <span class="ml-2">{{ sqw.contSize}} - </span>       
                <span>{{ sqw.contQty}} - </span>      
                <span>{{ sqw.cargoKg}} </span>      
              </div>
          </template>                
          <template #cell(detailsFght)="row" >
              <b-button size="sm" @click="openModalDetailsFght(row.item, row.index, $event.target )"  style="font-size:16px" variant="outline-dark" v-b-popover.hover.top="$t('getQuote.detailsFght')">
                  {{ row.item.fUSD.toFixed(0)}}
              </b-button>
          </template>
          <template #cell(detailsSur)="row" >
              <b-button size="sm" @click="openModalDetailsSur(row.item, row.index, $event.target )"  style="font-size:16px" variant="outline-dark" v-b-popover.hover.top="$t('getQuote.detailsSur')">
                  {{ row.item.surUSD.toFixed(0)}}
              </b-button>
          </template>          
          <template #cell(actCust)="row" >
            <b-button-group>
              <b-button class="m-1 text-dark" size="sm" variant="light" @click="actPreQInfo(row.item)" v-b-popover.hover.top="$t('bookingTx.preQInfoMsg')">
                {{ $t('bookingTx.preQInfo') }}
              </b-button>              
              <b-button class="m-1" v-show="row.item.actCust.editInfo" size="sm" variant="warning" @click="actEditInfo(row.item)" v-b-popover.hover.top="$t('bookingTx.editInfoMsg')">
                {{ $t('matchTx.edit') }}
              </b-button>
              <b-button class="m-1 " v-show="row.item.actCust.msgr" pill size="sm" variant="primary" @click="actMsgr(row.item)" v-b-popover.hover.top="$t('bookingTx.msgrMsg')">
                {{ $t('bookingTx.messenger') }}
              </b-button>
            </b-button-group>    
            <b-button-group>
              <b-button class="m-1" v-show="row.item.actCust.agentQ" size="sm" variant="dark" @click="actAgentQ(row.item)" v-b-popover.hover.top="$t('bookingTx.agentQMsg')">
                {{ $t('bookingTx.quote') }}
              </b-button>
              <b-button class="m-1" v-show="row.item.actCust.agentB" size="sm" variant="dark" @click="actAgentB(row.item)" v-b-popover.hover.top="$t('bookingTx.agentBMsg')">
                {{ $t('bookingTx.booking') }}
              </b-button>
            </b-button-group>                    
            <b-button-group>
              <b-button class="m-1" v-show="row.item.actCust.cancel" size="sm" variant="danger" @click="actCancel(row.item)" v-b-popover.hover.top="$t('bookingTx.cancelMsg')">
                {{ $t('matchTx.cancel') }}
              </b-button>
              <b-button class="m-1" v-show="row.item.actCust.approve" size="sm" variant="success" @click="actApprove(row.item)" v-b-popover.hover.top="$t('bookingTx.approveMsg')">
                {{ $t('shipApproval.approve') }}
              </b-button>
              <b-button class="m-1" v-show="row.item.actCust.reject" size="sm" variant="danger" @click="actReject(row.item)" v-b-popover.hover.top="$t('bookingTx.rejectMsg')">
                {{ $t('matchTx.reject') }}
              </b-button>              
            </b-button-group>
          </template>
          <template #empty>
              <h5>{{ $t('reuse.noRecord') }}</h5>
          </template>
        </b-table>
        <b-row>
          <div class="row col-sm-4 ">
            <b-col class="my-1 ml-3">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                class="my-0"
              ></b-pagination>
            </b-col>   
            <b-col sm="3" md="6" class="my-1">
              <b-form-group
                :label= "$t('require.perPage')"
                label-for="per-page-select"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-form-select
                  id="per-page-select"
                  v-model="perPage"
                  :options="pageOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </div>
        </b-row>
        <div>
          <b-modal id="jbBTxModal" :title="$t('matchTx.jobStatusDetails')"  title-tag="h3" size="lg" ok-only @hide="resetModalJbBTx">
          <div v-for="(item , index) in jbBTx" :key="index" class="my-loop-item">
            <div class="row">
            <h4 class="ml-2 my-1">&gt;</h4>
            <span class="ml-2 my-1">{{ $moment(item.timestamp).format("DD-MM-YY @ HH:mm") }}</span>
            <span class="ml-2 my-1"> {{ $t(`jbBTx.${item.jbBTx}`)  }}</span>
            </div>
          </div>
          </b-modal>
          <b-modal id="msgrModal" :title="`${$t('bookingTx.msgrDetails')} : ${selAgent}`" title-tag="h3" hide-footer size="lg" @hide="resetModalMsgr">
            <div v-for="(item , index) in msgr" :key="index" class="my-loop-item">
              <div class="row m-2">
                <h4 class="ml-2 my-1">&gt;</h4>
                <span class="ml-2 my-1">{{ $moment(item.timestamp).format("DD-MM-YY @ HH:mm") }}</span>
                <span class="ml-2 my-1 text-primary"> {{ item.msgr  }}</span>
              </div>
            </div>
            <div class="card mx-2 mt-3 gradient-wb ">
              <b-row>
                <b-col sm="1" class="mt-3">
                  <span class="text-primary f-w-800 ml-3" style="font-size:40px;">&rsaquo;</span>
                </b-col>
                <b-col sm="10">
                  <b-form-textarea
                    id="msgrInput"
                    v-model="msgrInput"
                    :placeholder="$t('bookingTx.msgrInput2AgentPh')"
                    rows="3"
                    max-rows="8"
                  ></b-form-textarea>
                </b-col>
                <b-col sm="1" class="mt-3">
                  <span v-show="msgrInput" class="text-white f-w-800" style="font-size:60px; font-weight: bold; cursor: pointer" @click="clickSend_Msgr">&rsaquo;</span>
                </b-col>
              </b-row>
            </div>
          </b-modal>
          <b-modal id="detailsCommodityModal" :title="$t('getQuote.commodity')" title-tag="h4" size="md" ok-only @hide="resetModalDetailsCommodity">
              <div class="row ml-2">
                  <h3 class="mt-3"> {{ $t('getQuote.commodity') }} :</h3>
                  <h3 class="mt-3 ml-2 text-info"> {{commodity }}</h3>
              </div>   
              <div class="row ml-2">
                  <h3 class="mt-3"> {{ $t('getQuote.dgGds') }} :</h3>
                  <h3 class="mt-3 ml-2 text-info"> {{$t(`getQuote.${dgGDs}`) }}</h3>
                  <!-- <h3 class="mt-3 ml-2 text-info"> {{$t('getQuote.'+ (dgGDs || false)) }}</h3> -->
              </div>                
              <div class="row ml-2">
                  <h3 class="mt-3"> {{ $t('hsCode.HS') }} :</h3>
                  <h3 class="mt-3 ml-2 text-info"> {{ hs6 }}</h3>
              </div>
          </b-modal>
          <b-modal id="detailsPortModal" :title="$t('freight.detailsPort')" title-tag="h4"  size="md" ok-only @hide="resetModalDetailsPort">
              <div class="row ml-2">
                  <h3 class="mt-3"> {{ $t('port.portId') }} :</h3>
                  <h3 class="mt-3 ml-2 text-info"> {{this.portId }}</h3>
              </div>   
              <div class="row ml-2">
                  <h3 class="mt-3"> {{ $t('port.pName') }} :</h3>
                  <h3 class="mt-3 ml-2 text-info"> {{this.pName }}</h3>
              </div>                
              <div class="row ml-2">
                  <h3 class="mt-3"> {{ $t('port.cntry') }} :</h3>
                  <h3 class="mt-3 ml-2 text-info"> {{ this.cntry }}</h3>
              </div>
          </b-modal>
          <b-modal id="detailsFghtModal" :title="$t('getQuote.detailsFght')" title-tag="h4"  size="md" ok-only @hide="resetModalDetailsFght">
              <b-table
                  sticky-header
                  head-variant="dark"
                  show-empty
                  bordered
                  responsive
                  sort-icon-left
                  stacked="md"
                  :items="itemsFght"
                  :fields="fieldsFght"
              >
                  <template #empty>
                      <h5>{{ $t('reuse.noRecord') }}</h5>
                  </template>
              </b-table>
          </b-modal>
          <b-modal id="detailsSurModal" :title="$t('getQuote.detailsSur')" title-tag="h3"  size="lg"  ok-only @hide="resetModalDetailsFght">
              <b-table
                  sticky-header
                  head-variant="dark"
                  show-empty
                  bordered
                  responsive
                  sort-icon-left
                  stacked="md"
                  :items="itemsSur"
                  :fields="fieldsSur"
              >
                  <template #empty>
                      <h5>{{ $t('reuse.noRecord') }}</h5>
                  </template>
                  <template #cell(detailsSurCode)="row" >
                      <b-button size="sm" @click="openModalDetailsSurCode(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('surcharge.detailsSurCode')">
                          {{ row.item.surCode}}
                      </b-button>
                  </template>
              </b-table>
          </b-modal>
          <b-modal id="detailsSurCodeModal" :title="$t('surcharge.detailsSurCode')" title-tag="h4"  size="md" ok-only @hide="resetModalDetailsSurCode">
              <div class="row ml-2">
                  <h3 class="mt-3"> {{ $t('surcharge.surCode') }} :</h3>
                  <h3 class="mt-3 ml-2 text-info"> {{this.selectedSurCode }}</h3>
              </div>   
              <div class="row ml-2">
                  <h3 class="mt-3"> {{ $t('surcharge.surDesc') }} :</h3>
                  <h3 class="mt-3 ml-2 text-info"> {{this.surDesc }}</h3>
              </div>                
              <div class="row ml-2">
                  <h3 class="mt-3"> {{ $t('slip.remark') }} :</h3>
                  <h3 class="mt-3 ml-2 text-info"> {{ this.remark}}</h3>
              </div>
          </b-modal>
          <b-modal id="cancelCustModal" header-text-variant="danger" title-tag="h3" :title="$t('bookingTx.cancelCustTitle')" size="md" hide-footer @hide="resetModalCancelCust">
            <div class="card m-2 gradient-wy ">
            <h3> {{ $t('bookingTx.confirmCancelMsg') }}</h3>
            </div>
            <div class="card m-2 gradient-wb ">
              <label for="msgrInput" class="col-form-label pt-0 f-w-600 ml-2" style="font-size:16px;"> {{ $t("bookingTx.msgrCancelCust") }}</label>                                                                       
              <b-form-input class="mx-2" style="font-size:16px;" v-model="msgrInput" type = "text" :placeholder="$t('bookingTx.msgrCancelPh')">                            
              </b-form-input>
              <b-form-radio-group
                class="mt-2"
                v-model="selectedReason"
                :options="cancelCustOptions"
                @input = "msgrInput = selectedReason" 
                plain
                size="md"
              ></b-form-radio-group>
            </div>
            <div class="row col-sm-12 ">
                <div class="col-sm-5 m-4">
                    <b-button variant="warning" style="font-size:20px" @click="resetModalCancelCust">{{ $t('matchTx.no') }}</b-button>
                </div>                
                <div class="col-sm-4 m-4">
                    <b-button variant="danger" style="font-size:20px" @click="clickYes_CancelCust">{{ $t('matchTx.yes') }}</b-button>
                </div>
            </div>
          </b-modal>
          <b-modal id="rejCustModal" header-text-variant="danger" title-tag="h3" :title="$t('bookingTx.rejCustTitle')" size="md" hide-footer @hide="resetModalRejCust">
            <div class="card m-2 gradient-wy ">
            <h3> {{ $t('bookingTx.confirmRejCustMsg') }}</h3>
            </div>
            <div class="card m-2 gradient-wb ">
              <label for="msgrInput" class="col-form-label pt-0 f-w-600 ml-2" style="font-size:16px;"> {{ $t("bookingTx.msgrRejAgent") }}</label>                                                                       
              <b-form-input class="mx-2" style="font-size:16px;" v-model="msgrInput" type = "text" :placeholder="$t('bookingTx.msgrRejectPh')">                            
              </b-form-input>
              <b-form-radio-group
                class="mt-2"
                v-model="selectedReason"
                :options="rejCustOptions"
                @input = "msgrInput = selectedReason" 
                plain
                size="md"
              ></b-form-radio-group>
            </div>
            <div class="row col-sm-12 ">
                <div class="col-sm-5 m-4">
                    <b-button variant="warning" style="font-size:20px" @click="resetModalRejCust">{{ $t('matchTx.no') }}</b-button>
                </div>                
                <div class="col-sm-4 m-4">
                    <b-button variant="danger" style="font-size:20px" @click="clickYes_RejCust">{{ $t('matchTx.yes') }}</b-button>
                </div>
            </div>
          </b-modal>
          <b-modal id="editInfoModal" hide-footer variant="info" title-tag="h3"  size="lg" :title="$t('bookingTx.editInfo')" @hide="resetModalEditInfo">
            <h4 class="text-primary mx-3">{{ $t('bookingTx.editInfoMsg') }}</h4>
            <div class="row col-sm-12 gradient-wo" role="group" >
              <div class="col-sm-9" >
                  <label for="shipper" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("getQuote.shipper") }}</label>
                  <b-form-input
                      id="shipper"
                      style="font-size:16px;" 
                      v-model="shipper"
                      type="text"
                      :formatter="formatter"
                      aria-describedby="input-live-help-shipper"
                      :placeholder="$t('getQuote.shipperPh')"
                  >
                  </b-form-input>
                  <b-form-text id="input-live-help-shipper">{{ $t("getQuote.shipperHelp") }}</b-form-text>           
              </div> 
              <div class="col-sm-3">
                  <label for="shipDateReqr" class="f-w-600 text-dark mt-1" style="font-size: 16px">{{ $t("getQuote.shipDateReqr") }}</label>
                  <datepicker input-class="datepicker-here form-control digits"  :disabled-dates="disabledDates"  :format="format" v-model="shipDateReqr" ></datepicker>
              </div>                    
            </div>
            <div class="col-sm-12" role="group">
                <label for="forwarder" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("getQuote.forwarder") }}</label>
                <b-form-input
                    id="forwarder"
                    style="font-size:16px;" 
                    v-model="forwarder"
                    type="text"
                    :formatter="formatter"
                    aria-describedby="input-live-help-forwarder"
                    :placeholder="$t('getQuote.forwarderPh')"
                >
                </b-form-input>
                <b-form-text id="input-live-help-forwarder">{{ $t("getQuote.forwarderHelp") }}</b-form-text>           
            </div>  
            <div class="col-sm-12 gradient-wo" role="group">
                <label for="cargoOwner" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("getQuote.cargoOwner") }}</label>
                <b-form-input
                    id="cargoOwner"
                    style="font-size:16px;" 
                    v-model="cargoOwner"
                    type="text"
                    :formatter="formatter"
                    aria-describedby="input-live-help-cargoOwner"
                    :placeholder="$t('getQuote.cargoOwnerPh')"
                >
                </b-form-input>
                <b-form-text id="input-live-help-cargoOwner">{{ $t("getQuote.cargoOwnerHelp") }}</b-form-text>           
            </div> 
            <div class="col-sm-12" role="group">
                <label for="POR" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("getQuote.POR") }}</label>
                <b-form-input
                    id="POR"
                    style="font-size:16px;" 
                    v-model="POR"
                    type="text"
                    :formatter="formatter"
                    aria-describedby="input-live-help-POR"
                    :placeholder="$t('getQuote.PORPh')"
                >
                </b-form-input>
                <b-form-text id="input-live-help-POR">{{ $t("getQuote.PORHelp") }}</b-form-text>           
            </div> 
            <div class="col-sm-12 gradient-wo" role="group">
                <label for="DEL" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("getQuote.DEL") }}</label>
                <b-form-input
                    id="DEL"
                    style="font-size:16px;" 
                    v-model="DEL"
                    type="text"
                    :formatter="formatter"
                    aria-describedby="input-live-help-DEL"
                    :placeholder="$t('getQuote.DELPh')"
                >
                </b-form-input>
                <b-form-text id="input-live-help-DEL">{{ $t("getQuote.DELHelp") }}</b-form-text>           
            </div> 
            <div class="row col-sm-12 mt-2" >
              <div class="col-sm-7 mb-3">
                <label for="commodity" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("getQuote.commodity") }}</label>                                                                       
                <b-form-input class="style-chooser" style="font-size:16px;" v-model="commodity" type = "text" :placeholder="$t('getQuote.commodityPh')">                            
                </b-form-input>
              </div>   
              <div class="col-sm-2">
                  <label for="hs6" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("hsCode.HS") }}</label>                                                                       
                  <b-form-input class="style-chooser" style="font-size:16px;" v-model="hs6" type = "text" :placeholder="$t('getQuote.addHS6')">                            
                  </b-form-input>
              </div>
              <div class="col-sm-2 ">
                  <label for="contGrade" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("require.contGrade") }}</label>                                                                       
                  <b-form-select class="style-chooser" style="font-size:16px;" v-model="contGrade" :options="optionsContGrade" :placeholder="$t('getQuote.contGradePh')">                            
                      <template #first>
                          <b-form-select-option :value="''" disabled>{{ $t("surcharge.plsSelect") }}</b-form-select-option>
                      </template>    
                  </b-form-select>
              </div>
            </div>
            <div class="row col-sm-12  my-2 mx-2">
                <div class="col-sm-4 m-4">
                    <b-button class="mx-2" style="font-size:18px;" variant="danger" block @click="resetModalEditInfo">
                        {{ $t('matchTx.cancel') }}
                    </b-button>  
                </div>
                <div class="col-sm-4 m-4">
                    <b-button class="mx-2" style="font-size:18px;" variant="warning" block @click="clickSaveEditInfo">
                        {{ $t('truck.ok') }}
                    </b-button>      
                </div>
            </div>
          </b-modal>  
          <b-modal id="agentQModal" 
            hide-footer 
            variant="info" 
            title-tag="h3"  
            size="lg" 
            :title="$t('bookingTx.agentQMsg')" 
            @hide="resetModalAgentQ"
          >
            <h3 class="text-primary mx-3">{{ $t('bookingTx.agentQuoteMsg') }}</h3>
            <div class="d-flex flex-row justify-content-end">
              <div class="mx-3" >
                  <b-button variant="success" style="font-size:16px"  @click="openFileQ">{{ $t('bookingTx.openFile') }}</b-button>
              </div>                
              <div class="ml-3 mr-5" >
                  <b-button variant="danger" style="font-size:16px" @click="resetModalAgentQ">{{ $t('matchTx.cancel') }}</b-button>
              </div>
            </div>                
            <div class=" card">
              <div v-if="agentQ.fileType == 'pdf'" >
                <vue-pdf-embed :source="agentQ.url" />
              </div>
              <div v-else class="container">
                  <img :src="agentQ.url" alt=" Quote Document"/>
              </div>
            </div>
          </b-modal>  
          <b-modal id="agentBModal" 
              hide-footer 
              variant="info" 
              title-tag="h3"  
              size="lg" 
              :title="$t('bookingTx.agentBookingTitle')" 
              @hide="resetModalAgentB"
          >
            <div class="row">
              <span class="text-dark ml-3 " style="font-size:20px">{{ $t('bookingId.bkgId') }} : </span>
              <span class="text-primary mx-2" style="font-size:20px">{{ agentB.no }}</span>
            </div>
            <div class="d-flex flex-row justify-content-end">
              <div class="mx-3" v-b-popover.hover.top="!isApplyBTx? $t('bookingTx.applyBTx2MTxMsg'):$t('bookingTx.appliedBTx2MTxMsg')" >
                  <b-button 
                      variant="primary" 
                      style="font-size:16px" 
                      :disabled="isApplyBTx"
                      @click="applyBTx2MTx" 
                     >{{ $t('bookingTx.applyBTx2MTx') }}</b-button>
              </div>
              <div class="mx-3" >
                  <b-button variant="success" style="font-size:16px"  @click="openFileB">{{ $t('bookingTx.openFile') }}</b-button>
              </div>                
              <div class="ml-3 mr-5" >
                  <b-button variant="danger" style="font-size:16px" @click="resetModalAgentB">{{ $t('matchTx.cancel') }}</b-button>
              </div>
            </div>                
            <div class="card">
              <div v-if="agentB.fileType == 'pdf'" >
                <vue-pdf-embed :source="agentB.url" />
              </div>
              <div v-else class="container">
                  <img :src="agentB.url" alt=" Booking Document "/>
              </div>
            </div>
          </b-modal>  
        </div>
        <div>
          <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :pdf-quality="1"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          :html-to-pdf-options ="htmlToPdfOptions"
          ref="html2PdfQR"
          >
          <section slot="pdf-content">
                  <div class="col-sm-12">
                      <div class="ml-2 mt-1  d-flex flex-row justify-content-between">
                          <div class="text-center ml-5"><img :src="require('../../assets/images/conex-logoSmall.png')" alt="conex"></div>                              
                          <h3 class="text-center text-primary mt-2 mb-1">QUOTE REQUEST</h3>
                          <div class="mr-5">
                              <div class="row">
                                  <h5 class="text-dark f-w-800 mx-2">Date :</h5>
                                  <span class="text-primary ml-1">{{ $moment().format(" DD-MMM-YYYY") }}</span>
                              </div>
                              <div class="row">
                                  <h5 class="text-dark f-w-800 mx-2">Ref No :</h5>
                                  <span class="text-primary ml-1">{{selItem.bTxId }}</span>   
                              </div>                            
                          </div>
                      </div>   
                      <b-row class="ml-4">     
                          <h4 class="text-dark">Ship Liner : </h4> 
                          <span class="ml-2 text-primary" style="font-size:18px;"> {{selItem.agent}} </span> 
                      </b-row>                                                 
                  </div>  
                      <b-card-group deck>
                          <b-card class="mx-4 ">
                              <b-row>
                                  <h5 class="ml-2 text-dark" >Contact Company :</h5>
                                  <span class="ml-2 text-primary"> {{ selQCompItem.compNameEng }}</span>
                              </b-row>
                              <!-- <b-row>
                                  <span class="ml-2 text-dark" >{{ $t('company.address') }} :</span>
                                  <span class="ml-2 text-primary"> {{ selQCompItem.compAddress }}</span>    
                              </b-row>                                     -->
                              <b-row class="d-flex flex-row justify-content-between">
                                  <b-row class="mx-2">
                                      <span class="text-dark" >Email :</span>
                                      <span class="ml-2 text-primary"> {{ selQCompItem.contactEmail }}</span>     
                                  </b-row>
                                  <b-row class="mx-3">
                                      <span class="text-dark" >Mobile :</span>
                                      <span class="ml-2 text-primary"> {{ selQCompItem.contactPhone }}</span>     
                                  </b-row>
                              </b-row>
                          </b-card>
                      </b-card-group>
                      <div class="ml-4 gradient-wy" >
                          <div class="d-flex flex-row justify-content-between"> 
                              <b-col class="my-1">
                                  <h4 class="text-dark">Shipper :</h4>                                                                   
                                  <span class="ml-2 text-primary" style="font-size:14px;"> {{ selItem.shipper }}</span>   
                              </b-col>
                              <b-col class="my-1">
                                  <h4 class="text-dark">Forwarder :</h4>                                                                   
                                  <span class="ml-2 text-primary" style="font-size:14px;"> {{ selItem.forwarder }}</span>             
                              </b-col>
                              <b-col class="my-1">
                                  <h4 class="text-dark">Cargo Owner :</h4>                                                                   
                                  <span class="ml-2 text-primary" style="font-size:14px;"> {{ selItem.cargoOwner }}</span>                                              
                              </b-col>
                          </div>
                      </div>
                      <div class="ml-4 gradient-wy" >
                          <div class="d-flex flex-row justify-content-between"> 
                              <b-col>
                                  <h4 class="tex-dark"> Commodity :</h4>                                                                       
                                  <span class="ml-2 text-primary" style="font-size:14px;" >{{ selItem.commodity }}</span>
                              </b-col>   
                              <b-col>
                                  <h4 class="text-dark">Danger Goods  :</h4> 
                                  <!-- <span  :class="`${selItem.dgGDs ? 'ml-2 text-danger' : 'ml-2 text-success' }`" style="font-size:14px;">{{  $t(`bookingTx.${selItem.dgGDs}`) }}</span> -->
                                  <span  :class="`${selItem.dgGDs ? 'ml-2 text-danger' : 'ml-2 text-success' }`" style="font-size:14px;">{{  $t('getQuote.'+ (selItem.dgGDs || 'false')) }}</span>
                                </b-col>                             
                              <b-col>
                                  <h4 class="text-dark"> HS-Code :</h4>       
                                  <span class="ml-2 text-primary" style="font-size:14px;" >{{ selItem.hs6 }}</span>                                                                
                              </b-col>
                          </div>
                      </div>  
                      <b-card-group deck>
                          <b-card class="mx-4 ">
                              <b-row>
                                  <b-col>
                                      <h4 class="ml-3"> Container : Size - Quatity - Cargo Weight</h4>
                                      <div
                                          v-for="(sqw, index) in selItem.contSQW"
                                          :key="index"
                                          class="select-group-sqw "
                                      >
                                          <span class="ml-2"># {{index + 1}}:</span>         
                                          <span class="ml-2">{{ sqw.contSize}} - </span>       
                                          <span>{{ sqw.contQty}} - </span>      
                                          <span>{{ sqw.cargoKg}} </span>      
                                      </div> 
                                  </b-col>
                                  <b-col>
                                      <b-row>
                                          <b-col>
                                              <h4 class="text-dark" > Type :</h4>                                                                       
                                              <span class="ml-2 text-primary" style="font-size:14px;"> {{ selItem.contType}}</span>                                                                       
                                          </b-col>
                                          <b-col>
                                              <h4 class="text-dark"> Grade :</h4>                                                                       
                                              <span class="ml-2 text-primary" style="font-size:14px;"> {{ selItem.contGrade }}</span>                                                                       
                                          </b-col>                                    
                                      </b-row>
                                      <b-row class="mt-1 ml-2">
                                          <h3 class="text-dark">Shipout Date :</h3>
                                          <span class="ml-2 text-primary" style="font-size:16px;"> {{ $moment(selItem.sdrTS).format('DD-MMM-YYYY') }}</span>
                                      </b-row>  
                                  </b-col>                                           
                              </b-row>
                              
                          </b-card>
                      </b-card-group>                                 
                      <div class="ml-4 gradient-wy" >
                          <div class="d-flex flex-row justify-content-between"> 
                              <b-col class="my-1">
                                  <h4 class="tex-dark"> POR-Place of Recept :</h4>                                                                       
                                  <span class="ml-2 text-primary" style="font-size:14px;" >{{ selItem.POR }}</span>
                              </b-col>   
                              <b-col class="my-1">
                                  <h4 class="text-dark"> DEL-Place of Delivery :</h4> 
                                  <span  class="ml-2 text-primary" style="font-size:14px;">{{ selItem.DEL }}</span>
                              </b-col>                           
                          </div>
                      </div>  
                      <div class="ml-4 mt-2  gradient-wy" >
                          <div class="d-flex flex-row justify-content-between my-2"> 
                              <b-col class="my-2">
                                  <h4 class="text-dark">POL-Port of Loading :</h4> 
                                  <span  class="ml-2 text-primary" style="font-size:14px;">{{ selItem.POL }}</span>
                              </b-col>                                     
                              <b-col class="my-2">
                                  <h4 class="tex-dark"> POD-Port of Destination:</h4>                                                                       
                                  <span class="ml-2 text-primary" style="font-size:14px;" >{{ selItem.POD }}</span>
                              </b-col>
                          </div>
                      </div>  
                  <div class="mx-4">
                      <h4 class="ml-4 "> Freight: (Preliminary)</h4>
                      <table class="table table-bordered table-striped mx-4">
                          <tr class="table-warning mr-4">
                              <th style="font-size: 14px">No</th>
                              <th style="font-size: 14px">Size</th>
                              <th>Qty</th>       
                              <th>Currency</th>   
                              <th >Amount</th>     
                              <th class="gradient-yg">USD</th>                                                     
                              <th >Rate</th>
                          </tr>
                          <tr v-for="( f, i) in selItem.fItems"
                              :key="f.id"
                          >
                              <td style="font-size: 12px">{{ i+1 }}</td>                                              
                              <td>{{f.contSize}}</td>
                              <td>{{ f.contQty }}</td>
                              <td>{{ f.fCurr }}</td>
                              <td>{{ f.fCalc }}</td>        
                              <td class="gradient-yg">{{ f.fUSD }}</td>                                   
                              <td>{{ f.fRate }}</td>  
                          </tr>
                          <tr>
                              <td></td><td></td><td></td><td></td><td>Total-USD = </td><td class="gradient-yg" style="font-weight: bold;">{{ selItem.fUSD }}</td>
                          </tr>
                      </table>
                  </div>       
                  <div class="mx-4">
                      <h4 class="ml-4 "> Surcharge : (Preliminary)</h4>
                      <table class="table table-bordered table-striped mx-4">
                          <tr class="table-warning">
                              <th style="font-size: 14px">No</th>
                              <th style="font-size: 14px">Code</th>
                              <th>Rate Base</th>                                    
                              <th class="gradient-gy">Currency</th>
                              <th>Amount</th>
                              <th class="gradient-yg">USD</th>  
                              <th>Rate</th>
                              <th>{{$t("freight.L20")}}</th>
                              <th>{{$t("freight.L40")}}</th>
                              <th>{{$t("freight.L40HC")}}</th>
                          </tr>
                          <tr v-for="( s, i) in selItem.surcharge"
                              :key="s.id"
                          >
                              <td style="font-size: 12px">{{ i+1 }}</td>                                              
                              <td>{{s.surCode}}</td>
                              <td>{{ s.rateBase }}</td>                                
                              <td>{{ s.sCurr }}</td>
                              <td>{{ s.surCalc }}</td> 
                              <td class="gradient-yg">{{ s.surUSD }}</td>                                  
                              <td>{{ s.surRate }}</td>
                              <td>{{ s.L20 }}</td>
                              <td>{{ s.L40 }}</td>                                
                              <td>{{ s.L40HC }}</td>
                          </tr>
                          <tr>
                              <td></td><td></td><td></td><td></td><td>Total-USD = </td><td class="gradient-yg" style="font-weight:bold">{{ selItem.surUSD }}</td><td></td><td></td><td></td>
                          </tr>
                      </table>
                  </div> 
                  <div class="divider mt-1 mx-4"> </div>                
          </section>
          </vue-html2pdf>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>

import { getData, getDataActive, updateBookingTx2StepN, saveWithId, mergeObj} from "../../firebase"
import {cancelCustOptions, rejCustOptions, contGrade} from '../../constants/config'
  export default {
    name: 'custBookingTx',
    data() {
      return {
        asOf : this.$moment().format( "HH:mm,  DD-MM-YYYY"),
        isApplyBTx:true,
        agentQ : '',
        agentB : '',
        selItem : '',  
        selQCompItem : '',
        selBTxId : '',
        selAgent : '',
        cancelCustOptions : cancelCustOptions,
        compId : '',
        portId : '',
        pName : '',
        cntry : '',
        selectedSurCode : '',
        surDesc : '',
        remark : '',
        jbBTx:[],
        msgr: [],
        msgrInput : '',        
        selectedReason : '',
        rejCustOptions : rejCustOptions,
        commodity : '',
        dgGDs : false,
        hs6 : '',
        shipper : '',
        forwarder : '',
        POR : '',
        DEL : '',
        cargoOwner : '',
        shipDateReqr : '',
        format: "yyyy-MM-dd",
        disabledDates: {
            to: new Date(Date.parse(new Date())+86400000),
        },
        contGrade : '',
        optionsContGrade : contGrade, 
        itemsFght : [],
        fieldsFght: [
            { key: 'contSize', label: this.$t('container.contSize'), sortable: true , variant: 'info'},                                                 
            { key: 'contQty', label: this.$t('getQuote.contQty'), sortable: true , variant: 'info'},  
            { key: 'fRate', label: this.$t('freight.fghtRate'), sortable: true , variant: 'info'}, 
            { key: 'fCurr', label: this.$t('freight.currency'), sortable: true, variant: 'primary' },  
            { key: 'fCalc', label: this.$t('freight.amount'), sortable: true, variant: 'primary' },        
            { key: 'fUSD', label: this.$t('freight.USD'), sortable: true, variant: 'warning' },  
            { key: 'cargoKg', label: this.$t('getQuote.cargoKg'), sortable: true , variant: 'info'},  

        ],
        itemsSur : [],
        fieldsSur : [
            { key: 'detailsSurCode', label: this.$t('surcharge.surCode'), sortable: true , variant: 'info'},
            { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, variant: 'primary' },   
            { key: 'rateBase', label: this.$t('surcharge.rateBase'), variant: 'primary' },        
            { key: 'sCurr', label: this.$t('freight.currency'), variant: 'primary' },    
            { key: 'surCalc', label: this.$t('freight.amount'), variant: 'primary' },  
            { key: 'surUSD', label: this.$t('freight.USD'), variant: 'warning' },    
            { key: 'surRate', label: this.$t('surcharge.surRate'), sortable: true , variant: 'secondary',
                formatter: value => {
                    return parseInt(value) == 0 ? "N/A" : value
            }}, 
            { key: 'L20', label: this.$t('freight.L20'), sortable: true , variant: 'secondary',
                formatter: value => {
                    return parseInt(value) == 0 ? "N/A" : value
                }
            }, 
            { key: 'L40', label: this.$t('freight.L40'), sortable: true , variant: 'secondary',
                formatter: value => {
                    return parseInt(value) == 0 ? "N/A" : value
            }}, 
            { key: 'L40HC', label: this.$t('freight.L40HC'), sortable: true , variant: 'secondary',
                formatter: value => {
                    return parseInt(value) == 0 ? "N/A" : value
            }}, 
        ],
        isBusy: false,     
        items: [],             
        fields: [
          { key: 'index', label: this.$t('seal.item'), sortable: true , variant: 'primary'},                 
          { key: 'bTxId', label: this.$t('bookingTx.bTxId'), sortable: true, variant: 'info',},  
          { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, variant: 'info' },                
          { key: 'fghtCat', label: this.$t('freight.fghtCat'), sortable: true , variant: 'info',},       
          { key: 'sctCode', label: this.$t('freight.sctCode'), sortable: true , variant: 'info',}, 
          { key: 'sdrTS', label: this.$t('getQuote.shipDateReqr'), sortable: true , variant: 'success', 
              formatter: value => {
                  return this.$moment(value).format("YYYY-MM-DD")
          }},              
          { key: 'POR', label: this.$t('bookingTx.POR'), sortable: true , variant: 'success',},                                
          { key: 'detailsPOL', label: this.$t('getQuote.POL'), sortable: true , variant: 'success'},  
          { key: 'detailsPOD', label: this.$t('getQuote.POD'), sortable: true , variant: 'success'}, 
          { key: 'DEL', label: this.$t('bookingTx.DEL'), sortable: true , variant: 'success',},       
          { key: 'jbBTx', label: this.$t('matchTx.jobStatus'), sortable: true, variant: 'danger',},  
          { key: 'detailsCommodity', label: this.$t('getQuote.commodity'), sortable: true , variant: 'primary'}, 
          { key: 'contSQWArr', label: this.$t('getQuote.contSQW'), sortable: true, variant: 'primary',thStyle:{width:'220px'} },
          { key: 'contType', label: this.$t('matchTx.contType'), sortable: true , variant: 'primary',                     
              formatter: value => {
                  return value.toUpperCase()
          }}, 
          { key: 'contGrade', label: this.$t('matchTx.gradeTh'), sortable: true, variant: 'primary' }, 
          { key: 'curr', label: this.$t('freight.currency'), sortable: true, variant: 'warning' },                             
          { key: 'detailsFght', label: this.$t('freight.header'), sortable: true , variant: 'warning'},  
          { key: 'detailsSur', label: this.$t('surcharge.header'), sortable: true , variant: 'warning'}, 
          { key: 'actCust', label: this.$t('matchTx.actions'), variant: 'secondary', thStyle:{width:'220px'} },     
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, variant: 'secondary',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }},           
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortBy: 'timestamp',
        sortDesc: true,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
      }
    },

    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      htmlToPdfOptions(){
        return {
          margin: 0,
          filename: `QR-${this.selItem.bTxId}`,
          image: {
            type: 'jpg', 
            quality: 0.98
          },
          enableLinks: false,
          html2canvas: {
            scale: 1,
            useCORS: true
          },
        }
      },
    },
    
    mounted() {
      this.compId= localStorage.getItem("compId")
      // getDataActive('BookingTx', 'qCompId', this.compId , (res)=>{
      //     this.items = res
      //     this.totalRows = res.length
      //   })
      this.getBookingData()
    },
    methods: {
      formatter(value) {
            return value.toUpperCase()
        },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      async getBookingData(){
        getDataActive('BookingTx', 'qCompId', this.compId , (res)=>{
          this.items = res
          this.totalRows = res.length
          this.isBusy = false
        })
      },
      async refreshBookingTx() {
        this.isBusy = true
        await this.getBookingData()
        this.selBTxId = ''
        this.msgrInput = ''
        this.selectedReason = ''
        this.asOf = this.$moment().format( "HH:mm,  DD-MM-YYYY")
      },
      async openModalJbBTx(item) {
        await getData( 'jbBTx' , 'id' , item.bTxId, (res)=>{
            this.jbBTx = res.sort((a,b)=>
              b.timestamp - a.timestamp
            )
            this.$root.$emit('bv::show::modal', "jbBTxModal")
        })
      },
      resetModalJbBTx() {
        this.jbBTx = []
        this.$root.$emit('bv::hide::modal', "jbBTxModal")
      },
      async openModalDetailsCommodity(item, index, button) {
        this.commodity = item.commodity
        this.dgGDs = item.dgGDs
        this.hs6 = item.hs6
        this.$root.$emit('bv::show::modal', "detailsCommodityModal" , button)
      },
      resetModalDetailsCommodity() {
        this.commodity = ''
        this.hs6 = ''
        this.dgGDs = false
        this.$root.$emit('bv::hide::modal', "detailsCommoditytModal")
      },      
      async openModalDetailsPOL(item, index, button) {
        await getData( 'Port' ,'id' , item.POL, (res)=>{
          this.portId = res[0].id
          this.pName = res[0].pName.trim()
          this.cntry = res[0].cntry
        })
        this.$root.$emit('bv::show::modal', "detailsPortModal" , button)
      },
      async openModalDetailsPOD(item, index, button) {
        await getData( 'Port' ,'id' , item.POD, (res)=>{
          this.portId = res[0].id
          this.pName = res[0].pName.trim()
          this.cntry = res[0].cntry
        })
        this.$root.$emit('bv::show::modal', "detailsPortModal" , button)
      },
      resetModalDetailsPort() {
        this.portId = ''
        this.pName = ''
        this.cntry = ''
        this.$root.$emit('bv::hide::modal', "detailsPortModal")
      }, 
      async openModalDetailsFght(item, index, button) {
          this.itemsFght = item.fItems
          // this.totalRowsFght = item.fItems.length
        this.$root.$emit('bv::show::modal', "detailsFghtModal" , button)
      },
      resetModalDetailsFght() {
          this.itemsFght = []
          this.$root.$emit('bv::hide::modal', "detailsFghtModal")
      },
      async openModalDetailsSur(item, index, button) {
          this.itemsSur = item.surcharge
          // this.totalRowsSur = item.surcharge.length
        this.$root.$emit('bv::show::modal', "detailsSurModal" , button)
      },
      resetModalDetailsSur() {
          this.itemsSur = []
          this.$root.$emit('bv::hide::modal', "detailsSurModal")
      },      
      async openModalDetailsSurCode(item, index, button) {
        await getData( 'SurCode' ,'id' , item.surCode, (res)=>{
          this.selectedSurCode= res[0].id
          this.surDesc = res[0].surDesc
          this.remark = res[0].remark
        })
        this.$root.$emit('bv::show::modal', "detailsSurCodeModal" , button)
      },
      resetModalDetailsSurCode() {
          this.selectedSurCode = ''
          this.surDesc = ''
          this.remark = ''
          this.$root.$emit('bv::hide::modal', "detailsSurCodeModal")
      },
      async actPreQInfo(item){
          this.selItem = item
          await getData( 'Company' , 'compId', item.qCompId, (res)=>{
              this.selQCompItem = res[0]
          }).then(()=>{
              this.$refs.html2PdfQR.generatePdf()
          })
      },
      async actCancel(item) {
        this.selBTxId = item.bTxId 
        this.selQCompId = item.qCompId,
        this.selAgent = item.agent,
        this.$root.$emit('bv::show::modal', "cancelCustModal")
      },
      async clickYes_CancelCust(){
        let ts = Date.parse(new Date())
        await updateBookingTx2StepN('BookingTx',this.selBTxId , 1.1 ).then(async()=>{
          await saveWithId('messenger', `${this.selBTxId}-${ts}`, {
            id : this.selBTxId,
            msgr : `Customer @Cancel: ${this.msgrInput}`,
            timestamp : ts,
          })
          await this.refreshBookingTx()
          this.$root.$emit('bv::hide::modal', "cancelCustModal")
        })     
      },
      resetModalCancelCust(){
        this.selBTxId = ''
        this.msgrInput = ''
        this.selectedReason = ''
        this.$root.$emit('bv::hide::modal', "cancelCustModal")
      },            
      actReject(item ) {
        this.selBTxId = item.bTxId 
        this.selQCompId = item.qCompId,
        this.selAgent = item.agent,
        this.$root.$emit('bv::show::modal', "rejCustModal")
      },     
      async clickYes_RejCust(){
        let ts = Date.parse(new Date())
        await updateBookingTx2StepN('BookingTx',this.selBTxId , 2.1 ).then(async()=>{
          await saveWithId('messenger', `${this.selBTxId}-${ts}`, {
            id : this.selBTxId,
            msgr : `Customer @Reject Quote: ${this.msgrInput}`,
            timestamp : ts,
          })
          await this.refreshBookingTx()
          this.$root.$emit('bv::hide::modal', "rejCustModal")
        })     
      },
      resetModalRejCust(){
        this.selBTxId = ''
        this.msgrInput = ''
        this.selectedReason = ''
        this.$root.$emit('bv::hide::modal', "rejCustModal")
      },  

      actApprove(item) {
        this.$bvModal.msgBoxConfirm(this.$t('matchTx.confirmAcceptMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          cancelVariant: 'warning',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async (value) => {
            if (value) {
              await updateBookingTx2StepN('BookingTx',item.bTxId , 3).then(async()=>{
                let ts = Date.parse(new Date())
                await saveWithId('messenger', `${item.bTxId}-${ts}`, {
                  id : item.bTxId,
                  msgr : 'Customer @Approve Quote',
                  timestamp : ts,
                })
                await this.refreshBookingTx()
              })
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Accept : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },
      actEditInfo(item){
        this.selBTxId = item.bTxId
        this.shipper = item.shipper
        this.forwarder = item.forwarder
        this.POR = item.POR
        this.DEL = item.DEL
        this.cargoOwner = item.cargoOwner
        this.commodity = item.commodity
        this.hs6 =item.hs6
        this.shipDateReqr = this.$moment(item.sdrTS).format("YYYY-MM-DD")
        this.contGrade = item.contGrade
        this.$root.$emit('bv::show::modal', "editInfoModal")
      },
      async refreshEditInfo(){
        this.selBTxId = ''
        this.shipper = ''
        this.forwarder = ''
        this.POR = ''
        this.DEL = ''
        this.cargoOwner = ''
        this.commodity = ''
        this.hs6 = ''
        this.shipDateReqr = ''
        this.contGrade = ''
      },      
      resetModalEditInfo() {
        this.refreshEditInfo()
        this.$root.$emit('bv::hide::modal', 'editInfoModal')
      },            
      async clickSaveEditInfo(){         
        let msg = 'completed'
        if (this.shipper ==='') {
            msg = 'getQuote.shipperPh'
        } else if (this.forwarder ===''){
            msg = 'getQuote.forwarderPh'
        } else if (this.POR ===''){
            msg = 'getQuote.PORPh'
        } else if (this.DEL ===''){
          msg = 'getQuote.DELPh'
        } else if (this.shipDateReqr== ''){
          msg = 'getQuote.addShipDateReqr'
        } else if (this.contGrade ===''){
          msg = 'container.selContGrade'
        } else if (this.commodity ==='') {
          msg = 'getQuote.commodityPh'
        } else if (this.hs6 ===''){
          msg = 'getQuote.addHS6'
        } 
        if (msg === 'completed'){ 
          let ts = Date.parse(new Date())
          await mergeObj('BookingTx', this.selBTxId, {
              shipper : this.shipper,
              forwarder : this.forwarder,
              POR : this.POR,
              DEL : this.DEL,    
              cargoOwner : this.cargoOwner,                                
              commodity : this.commodity,                
              hs6 : this.hs6, 
              sdrTS : Date.parse(this.shipDateReqr),                    
              contGrade: this.contGrade,  
              timestamp: ts,
          }).then(async()=>{
              await saveWithId('messenger', `${this.selBTxId}-${ts}`, {
                  id : this.selBTxId,
                  msgr : 'Customer : ลูกค้าแก้ไขข้อมูลทั่วไป',
                  timestamp : ts,
              })
              await saveWithId('jbBTx', `${this.selBTxId}-${ts}`, {
                  id : this.selBTxId,
                  jbBTx : 'editInfo',
                  timestamp : ts,
              })
              this.resetModalEditInfo() 
              this.refreshBookingTx()         
          })
        } else {
            this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
        }
      },
      async actMsgr(item){
        this.selBTxId = item.bTxId
        this.selAgent = item.agent
        await getData( 'messenger' , 'id' , item.bTxId, (res)=>{
            this.msgr = res.sort((a,b)=>
              b.timestamp - a.timestamp
            )
            this.$root.$emit('bv::show::modal', "msgrModal")
        })
      },
      resetModalMsgr() {
        this.msgr = []
        this.selBTxId = ''
        this.selAgent = ''
        this.msgrInput = ''
        this.$root.$emit('bv::hide::modal', "msgrModal")
      },
      async clickSend_Msgr(){
        let ts = Date.parse(new Date())
        await saveWithId('messenger', `${this.selBTxId}-${ts}`, {
          id : this.selBTxId,
          msgr : `Customer: ${this.msgrInput}`,
          timestamp : ts,
        }).then(()=>{
          this.resetModalMsgr()
        })
      },    
      
      actAgentQ(item){
        if (item.agentQ == '') {
          this.$toasted.show( 'Quote is not found.', {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 5000});   
        } else {
          this.selBTxId = item.bTxId
          this.agentQ = item.agentQ
          this.$root.$emit('bv::show::modal', "agentQModal")
        }
      },
      resetModalAgentQ(){
        this.selBTxId = ''
        this.agentQ = ''
        this.$root.$emit('bv::hide::modal', "agentQModal")
      },  
      openFileQ() {
        window.open(this.agentQ.url)
      },
      async actAgentB(item){
        if (item.agentB == '') {
          this.$toasted.show( 'Booking is not found.', {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 5000});   
        } else {
          this.selBTxId = item.bTxId
          this.agentB = item.agentB
          this.selAgent = item.agent

          await getData('BookingID', 'bkgId' , item.agentB.no, (res)=>{
            if (res.length == 0) {
              this.isApplyBTx = false
            }
          })
          this.$root.$emit('bv::show::modal', "agentBModal")
        }
      },
      resetModalAgentB(){
        this.selBTxId = ''
        this.agentB = ''
        this.isApplyBTx = true
        this.$root.$emit('bv::hide::modal', "agentBModal")
      },  
      openFileB() {
        window.open(this.agentB.url)
      },
      async applyBTx2MTx(){
        await saveWithId( 'BookingID' , this.agentB.no, {
          bkgId : this.agentB.no,
          compId : this.compId,
          fileUri : this.agentB.url,
          agent : this.selAgent,
          active : true,
          timestamp : Date.parse(new Date())
        }).then(()=>{
          this.$root.$emit('bv::hide::modal', "agentBModal")
        })
      }
    }
  }
</script>
<style scoped>
.my-loop-item {
  padding: 5px;
  margin-bottom: 2px;
  border: 1px solid #ccc;
}
.my-loop-item:first-child {
  background: linear-gradient(135deg, white, pink);
  font-weight: bold;
  font-size: 16px;
  border: 2px solid #00bcd4;
}
  .divider {
    height: 1px;
    background-color: #0f0f0f;
    margin:5px
  }
  .display-image {
    width: 100%;
    height: 450px;
    object-fit: scale-down;
    border-radius: 8px;
    background-color: #f5f5f5;
  }
 .gradient-wo {
   background: linear-gradient(135deg, white, orange);
 }
 .gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-wp {
   background: linear-gradient(135deg, white, pink);
 }
 .gradient-wb {
   background: linear-gradient(45deg, white, blue)
 }
 /* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN OFF */
  background-color: #ccc; /* Example: Gray when off */
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

/* Change background color of the slider when checked (ON state) */
input:checked + .slider {
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN ON */
  background-color: #2196F3; /* Example: Blue when on */
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}

.display-image {
  width: 100%;
  height: 450px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
}
.dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}

  .image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}
.tableInfo {
  text-align: center;
  color: #021001;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
</style>